import React, {useEffect, useRef} from 'react';
import gsap, {Back, Power1} from "gsap/gsap-core";

let imageId = 0;

export const RandomSmiles = () => {
    const myRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const e = myRef.current;

        const f2 = (id: number) => {


            const i = computeRandomImageId();

            const div = document.createElement('div');
            div.classList.add('random-smile');
            e!.appendChild(div);
            div.style.display = 'none';

            const inner = document.createElement('div');
            inner.classList.add('random-smile__inner');
            div.appendChild(inner);

            const img1 = document.createElement('img');
            img1.src = './img/smiles/smile-' + i + '.jpg';
            img1.classList.add('random-smile-smile');
            div!.appendChild(img1);

            const img2 = document.createElement('img');
            img2.src = './img/random-smile-frame.png';
            img2.classList.add('random-smile-frame');
            div!.appendChild(img2);

            const r = ((Math.PI * 2) / 6 * id) + Math.random();
            const range =20 + Math.random() * 25;

            const delay = Math.random()*.5;
            gsap.to(div,{
                delay,
                duration:4.6,
                y: -20 + (Math.random()* -20),
                ease:'none'
            });

            return gsap.timeline({delay})
                .set(div, {
                    left: 50 + (Math.cos(r) * range) + '%',
                    top: 50 + (Math.sin(r) * range) + '%',
                    scale: 0
                })
                .to(div, {
                    duration: .4,
                    display: 'block',
                    scale: 1,
                    ease: Back.easeOut,
                })
                .to(div, {
                    duration: .2,
                    delay: 4,
                    scale:0,
                    ease: Power1.easeIn,
                    onComplete: () => {
                        e!.removeChild(div);
                    }
                }).then();
        };

        const f3 = () => {
            Promise.all([
                    f2(1),
                    f2(2),
                    f2(3),
                    f2(4),
                    f2(5),
                    f2(6)
                ]
            ).then(() => {
                f3()
            });
        };
        f3();
    }, []);

    return (<div className={'random-smiles'} ref={myRef}></div>);
};

const computeRandomImageId = () => {
    imageId++;
    if (imageId > 72) imageId = 1;
    return imageId;
};